import axios                          from "axios";
import { isUserLoggedIn, isUserProf } from './Utils';

// https://github.com/Haroenv/floating.js/
// import floating from "floating.js";

axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

export default class Favourites
{
    constructor ()
    {

        this.favouriteBtns      = document.querySelectorAll( '.btn-favourite' );
        this.favouriteBtnsArray = Array.from( this.favouriteBtns );


        if ( this.favouriteBtns.length < 1 )
        {
            // no potential favourites? nothing to do
            return;
        }

        setTimeout( () => this.getFavourites(), 2000);
        this.bindEvents();
    }

    bindEvents ()
    {

        document.addEventListener( 'click', ( e ) =>
        {
            // loop parent nodes from the target to the delegation node
            for ( let target = e.target; target && target !== this; target = target.parentNode )
            {
                if ( typeof target.matches === 'function' && target.matches( '.btn-favourite' ) )
                {


                    e.preventDefault();

                    this.handleFavouriteClick( target );
                    break;
                }
            }
        }, false );


        document.addEventListener( 'AjaxRemarkFavourites', this.adjustAfterAjax.bind( this ) );

    }


    async getFavourites ()
    {

        let response = await axios.get( `/endpoints/favourites` );

        // console.log( 'Adjusting existing favourites', response.data?.data ?? 'no faves' );

        if ( response.data.success === true && response.data?.data?.length > 0 )
        {


            this.favourites = response.data.data;


            // console.log( 'this.favourites', this.favourites );

            if ( this.favourites.length > 0 )
            {

                this.highlightExistingFavourites();
            }


        }

    }

    highlightExistingFavourites ()
    {


        let found = [];

        this.favourites.forEach( fav =>
        {
            const foundMatches = this.favouriteBtnsArray.filter( btn => btn.dataset.postType === fav.post_type && parseInt( btn.dataset.postId ) === fav.id_content );

            // console.log( 'foundMatches', foundMatches )
            if ( foundMatches )
            {
                // console.log( 'Found Favourites  matches', foundMatches );
                foundMatches.forEach( fm => fm.classList.add( 'active' ) );
            }

            found.push( {
                lookingForPostType : fav.post_type,
                lookingForPostId   : fav.id_content,
                foundMatches       : foundMatches,
            } );

        } );

        // console.table( found );

    }


    async handleFavouriteClick ( clicked )
    {


        // const clicked  = event.currentTarget;
        const postType = clicked.dataset.postType;
        const postId   = clicked.dataset.postId;
        const audience = clicked.dataset.postAudience;

        // console.log( 'postType', postType, 'postId', postId, 'audience', audience, 'isUserProf()', isUserProf() );

        if ( !isUserLoggedIn() )
        {

            if ( audience === "jeunes" )
            {
                const event = new Event( 'openExplanationJeunes' );
                window.dispatchEvent( event );

                return;
            } else if ( audience === "profs" )
            {
                const event = new Event( 'openExplanationProfsSeulement' );
                window.dispatchEvent( event );

                return;
            }
        }

        /**
         * 2024-03-06 MB : Client aimerait que les profs puissent favoriter des articles de jeunes
        else if ( isUserProf() && audience === "jeunes" )
        {
            const event = new Event( 'openExplanationProfs' );
            window.dispatchEvent( event );

            return;
        }
        */

        else if ( isUserLoggedIn() && !isUserProf() && audience === "profs" )
        {
            const event = new Event( 'openExplanationJeunesActionProfsSeulement' );
            window.dispatchEvent( event );

            return;
        }

        // console.log( 'clicked', clicked, 'postType', postType, 'postId', postId, event );

        const isAlreadyFavourite = clicked.classList.contains( 'active' );


        if ( !isAlreadyFavourite )
        {

            // floating( {
            //     content  : "💖",
            //     number   : 2,
            //     duration : 3,
            //     repeat   : 1,
            //     size     : [ 5, 10 ],
            // } );


            const result = await this.addFavourite( postType, postId );


            if ( result )
            {
                clicked.classList.add( 'active' );


            }
        } else
        {

            // floating( {
            //     content   : "😭",
            //     number    : 2,
            //     duration  : 3,
            //     repeat    : 1,
            //     size      : [ 5, 10 ],
            //     direction : 'reverse',
            // } );


            const result = await this.removeFavourite( postType, postId );

            if ( result )
            {
                clicked.classList.remove( 'active' );


            }
        }


    }

    async addFavourite ( postType, postId )
    {
        let response = await axios.post( `/endpoints/favourites`, {
            postType : postType,
            postId   : postId,
            mode     : 'add',
        } );

        return response.data?.success ?? false;
    }


    async removeFavourite ( postType, postId )
    {
        let response = await axios.post( `/endpoints/favourites`, {
            postType : postType,
            postId   : postId,
            mode     : 'remove',
        } );

        return response.data?.success ?? false;
    }


    adjustAfterAjax ()
    {
        this.favouriteBtns      = document.querySelectorAll( '.btn-favourite' );
        this.favouriteBtnsArray = Array.from( this.favouriteBtns );


        if ( this.favourites && this.favourites.length > 0 )
        {
            this.highlightExistingFavourites();
        }
    }
}

